import { render, staticRenderFns } from "./android-buy.vue?vue&type=template&id=2c4e86e8&scoped=true"
import script from "./android-buy.vue?vue&type=script&lang=js"
export * from "./android-buy.vue?vue&type=script&lang=js"
import style0 from "./android-buy.vue?vue&type=style&index=0&id=2c4e86e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4e86e8",
  null
  
)

export default component.exports